import { render } from "./AModal.vue?vue&type=template&id=e684f9e0&scoped=true"
import script from "./AModal.vue?vue&type=script&lang=js"
export * from "./AModal.vue?vue&type=script&lang=js"

import "./AModal.vue?vue&type=style&index=0&id=e684f9e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e684f9e0"]])

export default __exports__